module.exports = __webpack_public_path__ + "img/1361957159_568268617.82b6865a.jpg";